import { $, _, Backbone, Marionette, moment, Radio } from "../../../../vendor";
import { Biscuit, Notification, FormatHelper } from "../../../utils";
import InboomaBaseView from "../../InboomaBaseView";
import InboomaBaseCollectionView from "../../InboomaBaseCollectionView";

import Product from "../../../models/Product";

import ProductsListTpl from "../../../templates/orders/ReservationForm/ProductsListTpl.html";
import ProductItemTpl from "../../../templates/orders/ReservationForm/ProductsListItemTpl.html";
import "typeahead.js";

const harmonizeModel = (model) => {
  if (typeof model.get("price") !== "object") {
    model.attributes.price = {
      single_price:
        typeof model.get("single_price") !== "undefined"
          ? Number(model.get("single_price"))
          : 0,
      price:
        typeof model.get("price") == "string" ? Number(model.get("price")) : "",
      amount:
        typeof model.get("amount") !== "undefined"
          ? Number(model.get("amount"))
          : 1,
      info:
        typeof model.get("price_info") !== "undefined"
          ? model.get("price_info")
          : "",
    };
  }
};

export const GetProductsAvailable = (contingent_ids, callback) => {
  const RequestHelper = Backbone.Model.extend({
    url: "/products/getRelatedProducts/" + contingent_ids,
  });

  const requestHelper = new RequestHelper().fetch({
    success(model, response) {
      callback(response.related_products);
    },
    error() {
      console.log("ERROR in GetProductsAvailable");
    },
  });
};
/**
 * The attributes order_item_price_id and is_updated are required for
 * price login in backend. This refs #19740
 */
const ProductItem = InboomaBaseView.extend({
  template: ProductItemTpl,
  className: "row force-float inb-reservation-product-item",

  ui: {
    pricetariffSelect: ".r-product-pricetariff",
    removeBtn: ".r-product-remove",
    freePriceField: ".free-price-field",
    lock: ".r-product-lock",
    amountInput: ".inb-reservation-product-item__amount-input",
    singlePriceField: ".single-price-field",
  },

  events: {
    "click @ui.removeBtn": "_remove",
    "click @ui.pricetariffSelect": "_changePricetariff",
    "keyup @ui.freePriceField": "_keyupFreePriceField",
    "focusout @ui.freePriceField": "_focusoutFreePriceField",
    "click @ui.lock": "_toggleLock",
    "change @ui.amountInput": "_updateAmount",
    "focusout @ui.singlePriceField": "_updateSinglePrice",
    "keyup @ui.singlePriceField": "_keyupSinglePriceField",
  },

  modelEvents: {
    "change:manual_override": "_updateReservationPrice",
    "change:price": "render",
  },

  templateContext() {
    harmonizeModel(this.model);
    let pricetariffs = null;
    if (typeof this.model.get("pricetariffs") !== "undefined") {
      pricetariffs = this.model.get("pricetariffs");
    }

    let description = this.model.get("description") || null;
    let name = this.model.get("name") || null;
    return {
      _,
      moment,
      pricetariffs,
      description,
      name,
      currency: Biscuit.getClientCurrency(),
      formatPrice: (price) =>
        Number(price).toLocaleString("de-DE", { minimumFractionDigits: 2 }),
    };
  },

  _toggleLock() {
    this.model.set("is_updated", true);
    this.model.set("manual_override", !this.model.get("manual_override"));
  },
  _changePricetariff() {
    const pricetariff_id = Number(this.getUI("pricetariffSelect").val());
    this.model.attributes.price.price = "";

    if (typeof pricetariff_id !== "undefined") {
      this.model.set("pricetariff_id", pricetariff_id);
      this.model.set("is_updated", true);
    }
  },

  // Prevents user from typing invalid characters
  _keyupFreePriceField(ev) {
    let val = ev.currentTarget.value;

    if (isNaN(val)) {
      val = val.replace(/[^0-9\,]/g, "");
      if (val.split(",").length > 2) {
        val = val.replace(/\,+$/, "");
      }
    }

    this.getUI("freePriceField").val(val);
  },
  _keyupSinglePriceField(ev) {
    let val = ev.currentTarget.value;

    if (isNaN(val)) {
      val = val.replace(/[^0-9\,]/g, "");
      if (val.split(",").length > 2) {
        val = val.replace(/\,+$/, "");
      }
    }

    this.getUI("singlePriceField").val(val);
  },

  _focusoutFreePriceField(ev) {
    let val = ev.currentTarget.value,
      apiFormattedPrice = Number(val.replace(",", "."));

    if (this.model.attributes.price.price == apiFormattedPrice) {
      // No action done by user
      return;
    }

    if (String(val).indexOf(",") < 0) {
      val += ",00";
      this.getUI("freePriceField").val(val);
    }

    this.model.attributes.price.price = apiFormattedPrice;
    this.model.attributes.is_updated = true;
    this.model.attributes.manual_override = true;
    this._updateReservationPrice();
  },

  _updateAmount(ev) {
    this.model.attributes.price.amount = ev.currentTarget.value;
    if (
      typeof this.model.attributes.price.single_price !== "undefined" &&
      this.model.attributes.price.single_price !== "" &&
      this.model.attributes.price.single_price > 0
    ) {
      this._updateReservationPrice();
    }
  },

  _updateSinglePrice(ev) {
    let val = ev.currentTarget.value,
      apiFormattedPrice = Number(val.replace(",", "."));

    if (this.model.attributes.price.single_price == apiFormattedPrice) {
      // No action done by user
      return;
    }

    if (String(val).indexOf(",") < 0) {
      val += ",00";
      this.getUI("singlePriceField").val(val);
    }

    this.model.attributes.price.single_price = apiFormattedPrice;
    if (
      typeof this.model.attributes.price.amount !== "undefined" &&
      this.model.attributes.price.amount >= 1
    ) {
      this._updateReservationPrice();
    }
  },

  _remove(ev) {
    ev.preventDefault();

    if (confirm(this.t("really_remove"))) {
      // Do not call directly this.model.destroy()
      // as this would trigger an API-request with DELETE method

      if (typeof this.model !== "undefined") {
        this.model.collection.remove(this.model);
        this.options.parentView.collection.remove(this.model);
        this.destroy();
        this.options.checkForEmptyProductCollection();
        this.options.reservationView.onChangeObserver.call(
          this.options.reservationView,
        );
        this.options.reservationView.getPrice();
      }
    }
  },

  _updateReservationPrice() {
    this.render();
    this.options.reservationView.getPrice();
  },

  onRender() {},

  initialize() {
    this.on("render", this.onRender); // ????
    // this.onRender();!!!
  },
});

export default InboomaBaseCollectionView.extend({
  childView: ProductItem,
  template: ProductsListTpl,
  childViewContainer: ".products-list",

  childViewOptions() {
    const that = this;

    return {
      products: this._products,
      reservationView: this.options.reservationView,
      checkForEmptyProductCollection() {
        that._toggleAddProductUnit(true);
      },
      parentView: this,
    };
  },

  collectionEvents: {
    add(model) {
      harmonizeModel(model);
      this.options.reservationView.getPrice();
      this.options.reservationView.onChangeObserver.call(
        this.options.reservationView,
      );

      this.options.reservationView.render();
      this._toggleAddProductUnit();
    },
  },

  templateContext() {
    let pricetariffsSet = false;
    if (typeof this._product.get("pricetariffs") !== "undefined") {
      if (this._product.get("pricetariffs").length > 0) {
        pricetariffsSet = true;
      }
    }
    let settedProducts =
      this.options.reservationView.options.model.get("summedProducts");

    return {
      product: this._product,
      t: this.t,
      name: this._product.get("name"),
      settedProducts: settedProducts,
    };
  },

  initialize() {
    Marionette.CollectionView.prototype.initialize.apply(this);

    const that = this,
      inputModel = _.first(this.collection.models);

    this._reservationEditMode =
      this.options.reservationView.model.get("id") !== "";

    this.productId = inputModel.get("id");
    this.name = inputModel.get("name");

    inputModel.set("productId", this.productId);

    // Set default product state
    this._product = new Product({
      name: inputModel.get("name"),
      productId: inputModel.get("productId"),
      description: inputModel.get("description"),
    });
    this.render();
  },

  onRender() {
    const that = this;
    let callGetPrice = false;

    _.each(this.collection.models, function (model) {
      if (model.attributes.price.price === "") {
        callGetPrice = true;
      }
    });

    if (callGetPrice) {
      window.setTimeout(function () {
        // This way we save some redundant calls on /getPrice
        that.options.reservationView.getPrice();
      }, 1500);
    }
  },

  _toggleAddProductUnit(isDeleteEvent = false) {
    const collectionModelsLength = this.collection.models.length;
    console.log(this.collection.models, "collectionModelsLength");
    if (collectionModelsLength === 0) {
      this.collection.models = [];
      this.destroy();
      return;
    }
  },

  /**
   * @method injectPricesIntoChildrenProductViews
   *
   * Usually called by ReservationsList.getPrice
   * Looks for any updatable prices and injects the new price
   *
   * @param {Object} prices As returned by API
   * @param {bool} forceReset Should prices be overwritten no matter what?
   */
  injectPricesIntoChildrenProductViews(prices, offset = 0) {
    const that = this;
    let pos = 0;
    const setProductsArr = function (price, ptId) {
      if (ptId.includes("_")) {
        let keys = ptId.split("_");
        ptId = keys[0];
        pos = keys[1];
      }
      let model = that.collection.models[pos];
      if (typeof model === "undefined") return;

      if (Number(model.get("id")) !== Number(ptId)) return;
      if (typeof price.price === "undefined") {
        _.each(price, function (pr, name) {
          model.attributes.price = {
            price: Number(pr.price),
            single_price: Number(pr.single_price),
            amount: Number(pr.amount),
            info: pr.info.replace(/for/g, "für"),
          };
        });
      } else {
        model.attributes.price = {
          price: Number(price.price),
          single_price:
            price.single_price !== null ? Number(price.single_price) : null,
          amount: Number(price.amount),
          info: price.info.replace(/for/g, "für"),
        };
      }

      // Re-render...
      model.trigger("change:price");
      // call onChangeObserver to ensure it is called after price changes
      that.options.reservationView.onChangeObserver.call(
        that.options.reservationView,
        that.injectPricesIntoChildrenProductViews,
      );
      //pos++;
    };
    _.each(prices, function (price, productId) {
      if (typeof price.length !== "undefined") {
        // = multiple product_prices

        _.each(price, function (pr, key) {
          setProductsArr(pr, productId + "_" + key);
        });
      } else {
        setProductsArr(price, productId);
      }
    });
  },

  /**
   * Get integer value from cid for comparison.
   *
   * @param str
   * @returns {Number}
   */
  parseItemCID(str) {
    let match = str.match(/[a-z]*(\d+)/);

    return parseInt(match[1]);
  },
});
